export enum AppTemplateTestIds {
  MENU_TOGGLE_BUTTON = 'app-template-menu-toggle-button',
  NAV_ITEM_PREFIX = 'app-template-nav-item-',
  NAV_LAYER_MAIN = 'app-template-nav-layer-main',
  NAV_LAYER_SUB = 'app-template-nav-layer-sub',
}
